import endpoints from "../config/endpoints";
import api from "../config/axios";

export const GetAllAgents = async (params) => {
    try {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`${endpoints.Agent.GetAllAgents}?${query}`);

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching orders:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error fetching products',
        };
    }
};

export const GetAgentById = async (agentId) => {
    try {
        const response = await api.get(`${endpoints.Agent.GetAgentById}?id=${agentId}`);

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching orders:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error fetching products',
        };
    }
};

export const AddAgent = async (formData) => {
    try {
        const response = await api.post(endpoints.Agent.AddAgent,formData);

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error("Error adding product:", error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: "Error adding product",
        };
    }
};

export const UpdateAgent = async (agentId,formData) => {
    try {
        const response = await api.put(
            `${endpoints.Agent.UpdateAgent}?id=${agentId}`,formData
        );

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error("Error updating product:", error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: "Error updating product",
        };
    }
};

export const DeleteAgent = async (agentId) => {
    try {
        const response = await api.delete(`${endpoints.Agent.DeleteAgent}?id=${agentId}`);
        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching orders:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error fetching products',
        };
    }
};

export const GetAllAgentCommissions = async (params) => {
    try {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`${endpoints.Agent.GetAllAgentCommissions}?${query}`);

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching orders:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error fetching products',
        };
    }
};

export const MarkPaid = async (agentId) => {
    try {
        const response = await api.post(`${endpoints.Agent.MarkPaid}?agentId=${agentId}`);
        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error in mark as paid:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error in mark as paid',
        };
    }
};

